import axios from "../../axios/interceptor.js";
import Toast from "../../component/toastify/Index";

export const getDashboardDataList = async (clientId) => {
    try {
        const response = clientId ? await axios.get(`/customer/dashboard/get?clientId=${clientId}`) : await axios.get(`/customer/dashboard/get`)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
};

export const getChartDataList = async (clientId) => {
    try {
        const response = clientId ? await axios.get(`/customer/dashboard/chart?clientId=${clientId}`) : await axios.get(`/customer/dashboard/chart`)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
};